import { createDrawingObject, replacePoint } from "../shared";
const Path = {
    name: "path",
    createDraft: (startPoint) => createDrawingObject("path", [startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replacePoint(draft, draft.points.length - 1, nextPoint),
    render: () => undefined,
};
export default Path;
